module.exports = __webpack_public_path__ + "static/media/synnove_3.6b57e856.PNG";